<template>
	<section>
		<!--列表-->
		<el-table :data="checks" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="weixin" label="微信" width="100">
			</el-table-column>
			<el-table-column prop="alipay" label="支付宝" width="100">
			</el-table-column>
			<el-table-column prop="cash" label="现金" width="100">
			</el-table-column>
			<el-table-column prop="pos" label="POS" width="100">
			</el-table-column>
			<el-table-column prop="sum" label="总金额" width="100">
			</el-table-column>
			<el-table-column prop="username" label="盘点员" width="100">
			</el-table-column>
			<el-table-column prop="createTime" label="盘点时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="200">
				<template scope="scope">
					<el-button type="primary" size="small" @click="checkDetail(scope.$index, scope.row)" icon="el-icon-search"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--订单详情界面-->
		<el-dialog title="订单详情" :visible.sync="ordersVisible" :close-on-click-modal="false">
			<el-table :data="orders" highlight-current-row v-loading="listLoading" style="width: 100%;">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="cdSn" label="订单号" width="150">
				</el-table-column>
				<el-table-column prop="sum" label="总金额" width="100">
				</el-table-column>
				<el-table-column prop="count" label="总数量" width="100">
				</el-table-column>
				<el-table-column prop="payway" label="付款方式" width="88">
				</el-table-column>
				<el-table-column prop="createTime" label="下单时间" width="180">
				</el-table-column>
			</el-table>
		</el-dialog>

	</section>
</template>

<script>
	import Cookies from 'js-cookie'
	import { getCheckList, getOrderList} from '../../api/api';

	export default {
		data() {
			return {
				pageSize:20,
				pages:0,
				checks: [],
				total: 0,
				page: 1,
				listLoading: false,

				ordersVisible: false,

				orders: []

			}
		},
		methods: {
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getOrders();
			},
			//获取结算列表
			getChecks() {
				let para = {
					page:this.page,
                    size:this.pageSize
				};
				this.listLoading = true;
				getCheckList(para).then((res) => {
					this.listLoading = false
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	this.checks = res.data.data.list;
	                }
				});
			},
			//盘点相关订单
			checkDetail: function (index, row) {
				let para = {
                    checkId:row.id
				};
				this.listLoading = true;
				this.ordersVisible = true;
				getOrderList(para).then((res) => {
					this.listLoading = false
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	this.orders = res.data.data.list
	                }
				});
			},
		},
		mounted() {
			this.getChecks();
		}
	}

</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

</style>